import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// Configurations
import Config from '@/config'

// Types
import type { APICRMAdminAccess, APICRMAdminItem } from '@/types/api/items/crm/crm-admin'
import type { SettingsStore } from '@/types/helpers/store/settings'

export const useSettingsStore = create<SettingsStore>()(
	persist(
		(set, get) => ({
			panelMenu: false,
			sidebarMenu: true,
			isOwner: false,
			admin: null,
			setPanelMenu: (panelMenu: boolean) => set({ panelMenu }),
			setSidebarMenu: (sidebarMenu: boolean) => set({ sidebarMenu }),
			setIsOwner: (isOwner: boolean) => set({ isOwner }),
			setAdmin: (admin: APICRMAdminItem | null) => set({ admin }),
			checkAccess: (access: APICRMAdminAccess) => {
				const state = get()

				if (state.isOwner) return true
				if (state.admin && state.admin[access]) return true

				return false
			},
			reset: () => set({ panelMenu: false, isOwner: false, admin: null })
		}),
		{
			name: `${Config.shortName}-settings`,
			storage: createJSONStorage(() => localStorage),
			...(typeof window !== 'undefined' && { storage: createJSONStorage(() => localStorage) }),
			partialize: state => ({
				sidebarMenu: state.sidebarMenu,
				isOwner: state.isOwner,
				admin: state.admin
			})
		}
	)
)
